// * This merge function   for  Styles list in builder. all_items will be styles object array and default_values_items will be the array of like this object ----> {key:["styles.key"], value:"your new dynamic value"} and remove_items will be just key_name of item

//*

export const merge_default_values = ({
  all_items,
  default_values_items = [],
  remove_items = [],
}) => {
  const updated_items_values = []

  for (let index = 0; index < all_items.length; index++) {
    let element = all_items[index]
    let updated_element = { ...element }
    const isDefaultValueShouldUpdate = default_values_items?.find((item) => item.key == element.key)
    if (isDefaultValueShouldUpdate) {
      updated_element.value = isDefaultValueShouldUpdate.value
    }

    if (!remove_items.includes(element.key)) {
      updated_items_values.push(updated_element)
    }
  }

  return updated_items_values
}
